import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

/* ===============================
   UPSERT BUSINESS PROFILE
================================ */
export const upsertBusinessProfile = createAsyncThunk(
  "businessProfile/upsertBusinessProfile",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await api.post(
        "/invoiceProfile/upsert-detail",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* ===============================
   GET VENDOR BUSINESS PROFILE
================================ */
export const getVendorBusinessProfile = createAsyncThunk(
  "businessProfile/getVendorBusinessProfile",
  async (vendorId, { rejectWithValue }) => {
    try {
      const res = await api.get(
        `/invoiceProfile/get-detail/${vendorId}`
      );
      return res.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* ===============================
   SLICE
================================ */
const businessProfileSlice = createSlice({
  name: "businessProfile",
  initialState: {
    profile: null,
    loading: false,
    success: false,
    error: null,
  },

  reducers: {
    clearBusinessProfileState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
    clearBusinessProfile: (state) => {
      state.profile = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* 🔹 UPSERT */
      .addCase(upsertBusinessProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(upsertBusinessProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.profile = action.payload;
      })
      .addCase(upsertBusinessProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* 🔹 GET */
      .addCase(getVendorBusinessProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVendorBusinessProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(getVendorBusinessProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearBusinessProfileState,
  clearBusinessProfile,
} = businessProfileSlice.actions;

export default businessProfileSlice.reducer;
